"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_15bof8v1eo() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Home.tsx";
  var hash = "2e58813ab28a352eb485367b43d80de7f3c82fbf";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Home.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2e58813ab28a352eb485367b43d80de7f3c82fbf"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15bof8v1eo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_15bof8v1eo();
var Icon = (cov_15bof8v1eo().s[0]++, {
  name: 'home',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 10.3016L12 5.05164L4.5 10.3016V19.5H7.5V14.5C7.5 12.0147 9.51472 10 12 10C14.4853 10 16.5 12.0147 16.5 14.5V19.5H19.5V10.3016ZM22 9.52066V21C22 21.5523 21.5523 22 21 22H14V14.5C14 13.3954 13.1046 12.5 12 12.5C10.8954 12.5 10 13.3954 10 14.5V22H3C2.44772 22 2 21.5523 2 21V9.52066C2 9.19434 2.15921 8.88855 2.42654 8.70143L11.4265 2.40143C11.7709 2.1604 12.2291 2.1604 12.5735 2.40143L21.5735 8.70143C21.8408 8.88855 22 9.19434 22 9.52066Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;